import { TokenPurposeDialog } from '@modules/projectAccessTokens/components/TokenPurposeDialog';
import { Alert, Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

export const MagicLinkPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { formatMessage } = useIntl();
  const token = useMemo(() => searchParams.get('token'), [searchParams]);

  if (!token) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" p={3}>
        <Stack spacing={2} maxWidth={480}>
          <Alert severity="error">
            {formatMessage({ id: 'Access token is required.' })}
          </Alert>
          <Typography variant="body2" color="text.secondary">
            {formatMessage({ id: 'Use the link from your email to access this page.' })}
          </Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <TokenPurposeDialog
      token={token}
      open
      onClose={() => {}}
      disableClose
    />
  );
};
